import { useState, useCallback } from 'react';

export const useLabelOverflow = () => {
	const [labelOverflows, setLabelOverflows] = useState<boolean>(false);

	const onLabelRef = useCallback(
		(node: HTMLElement | null) => {
			if (node != null) {
				const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
				isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
			}
		},
		[labelOverflows],
	);

	return {
		labelOverflows,
		onLabelRef,
		setLabelOverflows,
	};
};
